// Shared helpers for TimerBar sub-components.
export function pad2(n) { return String(n).padStart(2, "0"); }

export function toTimeStr(d) {
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function toDateStr(d) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function parseDateTime(dateStr, timeStr) {
  const [y, m, day] = dateStr.split("-").map(Number);
  const [h, min] = (timeStr || "0:0").split(":").map(Number);
  return new Date(y, (m || 1) - 1, day || 1, h || 0, min || 0, 0, 0);
}

export function arraysEqual(a, b) {
  if (a === b) return true;
  if (!Array.isArray(a) || !Array.isArray(b)) return false;
  if (a.length !== b.length) return false;
  const sa = [...a].sort();
  const sb = [...b].sort();
  return sa.every((v, i) => v === sb[i]);
}
